import { render, staticRenderFns } from "./SendCapiEventModal.vue?vue&type=template&id=0ac284a4&scoped=true"
import script from "./SendCapiEventModal.vue?vue&type=script&lang=js"
export * from "./SendCapiEventModal.vue?vue&type=script&lang=js"
import style0 from "./SendCapiEventModal.vue?vue&type=style&index=0&id=0ac284a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac284a4",
  null
  
)

export default component.exports